<div class="p-2 menu-navigation">
  <mat-nav-list>
    <a
      mat-list-item
      [href]="zendeskLink"
      target="_blank"
      *accessView="['view_zendeskticket']"
      data-testId="zendesk_button"
    >
      <div class="menu-item">
        <mat-icon class="icon">headset_mic</mat-icon>
        <div class="menu-item-text">Support</div>
      </div>
    </a>

    <a mat-list-item [href]="mailToSupport" data-testId="feedback_button">
      <div class="menu-item">
        <mat-icon class="icon">feedback</mat-icon>
        <div class="menu-item-text">Feedback</div>
      </div>
    </a>

    @if (version(); as version) {
      @if (version.link) {
        <a mat-list-item [href]="version.link" target="_blank" data-testId="version_button_with_link">
          <div class="menu-item">
            <div class="menu-item-version">{{ version.version_number }}</div>
          </div>
        </a>
      } @else {
        <div class="version-container" data-testId="version_text_without_link">
          <div class="menu-item-version-no-link-text menu-item-version">{{ version.version_number }}</div>
        </div>
      }
    }
  </mat-nav-list>
</div>
